import { flatten, groupBy, sortBy } from 'es-toolkit/compat';

import type { Period } from '../common/termedLevel/types';

export function sortRatePlans<T extends { variantName?: string; contractPeriod?: Period; level?: string }>(
    productRatePlans: T[]
): T[] {
    const groupedRatePlans = groupBy(sortBy(productRatePlans, 'level'), (ratePlan: T) => ratePlan.variantName);
    return flatten(
        Object.values(groupedRatePlans).map((ratePlans: T[]) =>
            sortBy(ratePlans, (ratePlan: T) => ratePlan.contractPeriod?.length ?? 0)
        )
    );
}
